export default __webpack_public_path__ + "boss-hits-hero-c41479ca21a1e4fbad08a95acf9598e0.mp3";